module.exports = require('./helpers/bundle-url').getBundleURL('jnZxP') + "logo.c51670a8.svg";